import type { TourStep } from "../types";

export const overviewSteps: TourStep[] = [
  {
    title: "Overview",
    description:
      "How the scheme is performing over the period you choose. Almost every number here is a link — click one to open the matching filtered list.",
  },
  {
    anchor: "overview-scope-bar",
    title: "Scope everything below",
    description:
      "Period, Status, Category, Department, Unit and Reward category. What you set here scopes every figure on the page, and Print and Export carry the same scope.",
  },
  {
    anchor: "overview-hero",
    title: "Closure rate and timing",
    description:
      "The headline is the share of in-scope suggestions that reached closure, compared against the previous period. The tiles beneath cover median time to close and suggestions left ageing.",
  },
  {
    anchor: "overview-pipeline",
    title: "Pipeline",
    description:
      "Counts down the happy path — submitted, through WC and SC review, to implementation and closure — with the rejections that dropped out along the way.",
  },
  {
    anchor: "overview-breakdowns",
    title: "Breakdowns",
    description:
      "The same population split by department, category, status and reward category. Bars are proportional to the total in scope; click a row to open that slice.",
  },
  {
    anchor: "overview-committee",
    title: "Committee Report",
    description:
      "The Steering Committee report for the same scope: received, recommended and rejected by WC, approved and rejected by SC, implemented and closed. Below it, the best suggestions by SC rating, who had the most approved, the top units and departments, and every SC evaluation with its rating, reward category and remark.",
  },
  {
    anchor: "overview-actions",
    title: "Print and export",
    description:
      "Print opens a document-style version of this page in a new tab, with the same figures and the Committee Report. Export downloads the same report as a spreadsheet — a sheet per section, the SC evaluations, and the suggestions themselves.",
  },
];
